import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { queryClient } from './api/queryClient';
import { ThemeProvider } from './components/ThemeProvider';
import { AuthProvider } from './auth/AuthContext';
import { seedDemoScansIfEmpty } from './domain/scanStore';
import i18n from './i18n';
import App from './App';

// Expose i18n sur window pour debug console F12.
(window as unknown as { i18next?: typeof i18n }).i18next = i18n;

const persister = createSyncStoragePersister({
  storage:      window.localStorage,
  key:          'nis365-query-cache',
  throttleTime: 1000,
});

// Pre-remplit le store de demo si vide pour eviter une page blanche au 1er run.
seedDemoScansIfEmpty();

// Config i18n minimale - resources synchrones + lng define -> isInitialized
// est true immediatement. Plus de I18nextProvider, plus de createInstance.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{
          persister,
          maxAge:          24 * 60 * 60 * 1000,
          dehydrateOptions:{
            shouldDehydrateQuery: (q) => q.state.status === 'success',
          },
          buster: 'v1',
        }}
      >
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </PersistQueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
